jQuery(document).ready(function ($) {




    $(window).on('scroll', function () {

        var pos1 = $(".OurSolutions-sidebar");
        if (pos1.length) {
            var position1 = pos1.position().top;
        }
        var pos2 = $(".OurSolutions-card_inner-1");
        if (pos2.length) {
            var positionEl2 = pos2.position().top - 200;
        }
        var pos3 = $(".OurSolutions-card_inner-2");
        if (pos3.length) {
            var positionEl3 = pos3.position().top - 200;
        }
        var pos4 = $(".OurSolutions-card_inner-3");
        if (pos4.length) {
            var positionEl4 = pos4.position().top - 200;
        }
        var pos5 = $(".OurSolutions-card_inner-4");
        if (pos5.length) {
            var positionEl5 = pos5.position().top - 200;
        }
        var pos6 = $(".OurSolutions-card_inner-5");
        if (pos6.length) {
            var positionEl6 = pos6.position().top - 200;
        }


        if (position1 >= positionEl2) {
            $(".sticky-wrapper-0").removeClass('fade-in');
            $(".sticky-wrapper-1").addClass('fade-in');
            $(".sticky-wrapper-2").removeClass('fade-in');
            $(".sticky-wrapper-3").removeClass('fade-in');
            $(".sticky-wrapper-4").removeClass('fade-in');
        } else {
            $(".sticky-wrapper-0").addClass('fade-in');
            $(".sticky-wrapper-1").removeClass('fade-in');
            $(".sticky-wrapper-2").removeClass('fade-in');
            $(".sticky-wrapper-3").removeClass('fade-in');
            $(".sticky-wrapper-4").removeClass('fade-in');
        }

        if (position1 > positionEl3) {
            $(".sticky-wrapper-1").removeClass('fade-in');
            $(".sticky-wrapper-0").removeClass('fade-in');
            $(".sticky-wrapper-3").removeClass('fade-in');
            $(".sticky-wrapper-4").removeClass('fade-in');
            $(".sticky-wrapper-2").addClass('fade-in');

        }
        if (position1 > positionEl4) {
            $(".sticky-wrapper-1").removeClass('fade-in');
            $(".sticky-wrapper-0").removeClass('fade-in');
            $(".sticky-wrapper-2").removeClass('fade-in');
            $(".sticky-wrapper-3").addClass('fade-in');
        }
        if (position1 > positionEl5) {
            $(".sticky-wrapper-1").removeClass('fade-in');
            $(".sticky-wrapper-0").removeClass('fade-in');
            $(".sticky-wrapper-2").removeClass('fade-in');
            $(".sticky-wrapper-3").removeClass('fade-in');
            $(".sticky-wrapper-4").addClass('fade-in');
        }
        if (position1 > positionEl6) {
            $(".sticky-wrapper-1").removeClass('fade-in');
            $(".sticky-wrapper-0").removeClass('fade-in');
            $(".sticky-wrapper-2").removeClass('fade-in');
            $(".sticky-wrapper-3").removeClass('fade-in');
            $(".sticky-wrapper-4").removeClass('fade-in');
            $(".sticky-wrapper-5").addClass('fade-in');
        }
    });
});